import { PLANAI_CORE_TRAILS } from "../planai-core";

export const PLANAI_BIKE_TIMETABLE = "https://www.planai.at/en/activities/bikepark-schladming";
export const PLANAI_BIKE_PERIODS = [
  { from: "2026-05-14", to: "2026-05-17", weekdays: [4, 5, 6, 0], ascentClose: 17, trailClose: 18 },
  { from: "2026-05-20", to: "2026-09-20", ascentClose: 17, trailClose: 18 },
  { from: "2026-09-24", to: "2026-10-04", weekdays: [4, 5, 6, 0], ascentClose: 17, trailClose: 18 },
  { from: "2026-10-08", to: "2026-10-24", ascentClose: 17, trailClose: 18 },
  { from: "2026-10-25", to: "2026-11-01", ascentClose: 16, trailClose: 17 },
] as const;

/** Version two binds the pass to an exact, dated operator trail calendar.
 * Version-one readers reject its different conditionalAccess discriminator. */
export type PlanaiTrailPass = {
  validFrom: "2026-05-14";
  validTo: "2026-11-01";
  calendar: "planai-2026";
  sourceTrailId: string;
};
const identities = new Set<string>(PLANAI_CORE_TRAILS.map(trail => trail.osmId));

export function planaiTrailPass(osmId: string): PlanaiTrailPass | undefined {
  return identities.has(osmId)
    ? { validFrom: "2026-05-14", validTo: "2026-11-01", calendar: "planai-2026", sourceTrailId: osmId }
    : undefined;
}

/** The closing hour is a COMPLETION deadline, not a latest trail entry.
 * The separately loaded active source identity must corroborate the marker. */
export function planaiTrailWindow(pass: unknown, date: unknown, sourceId: string | null | undefined): { open: number; close: number } | null {
  if (!pass || typeof pass !== "object" || Array.isArray(pass) || typeof sourceId !== "string" || !identities.has(sourceId)) return null;
  const policy = pass as Record<string, unknown>;
  if (policy.calendar !== "planai-2026" || policy.validFrom !== "2026-05-14" || policy.validTo !== "2026-11-01" || policy.sourceTrailId !== sourceId) return null;
  if (typeof date !== "string" || !/^2026-\d{2}-\d{2}$/.test(date) || date < policy.validFrom || date > policy.validTo) return null;
  const month = Number(date.slice(5, 7)), day = Number(date.slice(8, 10));
  if (day < 1 || day > ([4, 6, 9, 11].includes(month) ? 30 : 31)) return null;
  const period = PLANAI_BIKE_PERIODS.find(period => date >= period.from && date <= period.to);
  if (!period || ("weekdays" in period && !(period.weekdays as readonly number[]).includes(new Date(`${date}T12:00:00Z`).getUTCDay()))) return null;
  return { open: 9, close: period.trailClose };
}
